var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "legal__section" }, [
      _c("h1", [_vm._v("Flixel Sales Policy")]),
      _c("h2", [_vm._v("General Conditions")]),
      _c("p", [
        _vm._v(
          "All Flixel products and services are available as a free, full-featured trial for an unlimited amount of time. The limitation of the free trial is a Flixel logo watermark. The trial ensures that customers can fully evaluate the product in their own time. After careful evaluation, customers can purchase to unlock and remove the watermark. Products and services are available for purchase from the Flixel online store or on the App Store. For consistency, the Flixel online store policy follows the "
        ),
        _c(
          "a",
          {
            staticClass: "link dark",
            attrs: {
              href: "https://www.apple.com/legal/internet-services/itunes/"
            }
          },
          [_vm._v("App Store policy")]
        ),
        _vm._v("."),
        _c("strong", [_vm._v(" All sales final")]),
        _vm._v(".")
      ]),
      _c("h2", [_vm._v("Purchase Options")]),
      _c("p", [
        _vm._v(
          "Flixel applications may be unlocked with a license or with a subscription to some Flixel plans. Flixel Cloud hosting services and custom plans with more storage or embed counts are available upon request."
        )
      ]),
      _c("h2", [_vm._v("Licenses")]),
      _c("p", [
        _vm._v(
          "Licenses are application, major version, and platform specific. For example, a license for Cinemagraph Pro 2 for macOS only unlocks the 2.x version of the macOS application, and does not unlock Cinemagraph Pro for iOS. For new major versions of applications, upgrade pricing will be available for previous major version licensees. Online store application license agreements are available in the applications. For App Store applications, license agreements are available from the App Store product page."
        )
      ]),
      _c("p", [
        _vm._v(
          "A license grants the right to activate and use the application on either (a) one device used by multiple people, or (b) several devices, within reasonable limits, used by one and the same person. Flixel may in its sole discretion define and adjust what said reasonable limits amount to per customer. A license does not allow multiple users to use the application on multiple devices."
        )
      ]),
      _c("h2", [_vm._v("Subscriptions")]),
      _c("p", [
        _vm._v(
          "Flixel plans are periodic auto-renewing prepaid subscriptions. Subscriptions can be cancelled at anytime before renewal. Cancelled subscriptions remain active until the end of the purchased period. Flixel plans are associated with one Flixel.com user account. The account may not be shared among multiple people. Flixel reserves the right to terminate a plan if inappropriate use is detected."
        )
      ]),
      _c("h2", [_vm._v("Stores")]),
      _c("h3", [_vm._v("Flixel Online Store")]),
      _c("p", [
        _vm._v(
          "The Flixel online store is available at flixel.com or the in-app store in apps downloaded from flixel.com. Our order process is conducted by our online reseller"
        ),
        _c(
          "a",
          { staticClass: "link dark", attrs: { href: "https://paddle.com" } },
          [_vm._v(" Paddle.com")]
        ),
        _vm._v(
          ". Paddle.com is the Merchant of Record for all our orders.  Paddle provides all customer service inquiries and handles returns. For all other inquiries "
        ),
        _c(
          "a",
          {
            staticClass: "link dark",
            attrs: { href: "mailto:support@flixel.com" }
          },
          [_vm._v("contact Flixel Support")]
        ),
        _vm._v(".")
      ]),
      _c("h3", [_vm._v("Apple App Store")]),
      _c("p", [
        _vm._v(
          "Licenses and subscriptions are available for purchase from apps downloaded on the"
        ),
        _c(
          "a",
          { staticClass: "link dark", attrs: { href: "https://appstore.com" } },
          [_vm._v(" App Store")]
        ),
        _vm._v(
          ". Unfortunately Flixel support cannot help if you have a problem with your App Store transaction. Please contact Apple directly within 90 days of purchase"
        ),
        _c(
          "a",
          {
            staticClass: "link dark",
            attrs: { href: "http://reportaproblem.apple.com/" }
          },
          [_vm._v(" here")]
        ),
        _vm._v(".")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a28403e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a28403e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/legal/SalesPolicy.vue
// module id = null
// module chunks = 